module.exports = __webpack_public_path__ + "static/social-icon-3ce825a2ed10e29472ec26034c8f1214.jpg";